import React from 'react'
import BuyerProfile from './Partial/BuyerProfile'
import CartSection from './Partial/CartSection'
import Menubar from './Partial/Menubar'

export default function Checkout() {
  return (
    <>
      <Menubar title="Checkout Page" />
      <BuyerProfile title="Profile Page" />
      <CartSection title="Checkout" />
    </>
  )
}
